import { render, staticRenderFns } from "./AddToWaitingListButton.vue?vue&type=template&id=1a2f84b6&"
import script from "./AddToWaitingListButton.vue?vue&type=script&lang=js&"
export * from "./AddToWaitingListButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports